import {
  HardFormFieldTypeEnum,
  HardTableColumnTypeEnum,
  IHardFormField,
} from "@hardcode-kz/ui";
import { IBaseConfig, ITable } from "@models/form/base-config";
import { IShift } from "@dmms/shared/data-access/resource-management/models/shift";
import { PathIcons } from "@static/icons/path-icons";
import { formatTimeField } from "@dmms/shared/utils/functions";
import { LangEnum } from "@models/interface-management/localization";
import { TranslationFieldPartialValidator } from "@static/fields/fields-constant";
import { ResourceManagementEndpoints } from "@dmms/shared/data-access/resource-management/types/resource-management-endpoints";

export class ShiftConfig implements IBaseConfig {
  version = 1;
  dicType = ResourceManagementEndpoints.Shift;
  title = "Рабочие смены";

  fields: IHardFormField<any>[] = [
    {
      name: "name",
      params: {
        direction: "row",
        fields: TranslationFieldPartialValidator(
          "Наименование",
          HardFormFieldTypeEnum.Input,
          [LangEnum.RU],
        ),
      },
    },
    {
      params: {
        direction: "row",
        fields: [
          {
            name: "shiftNumber",
            title: "Номер смены",
            type: HardFormFieldTypeEnum.Number,
          },
          {
            name: "startTime",
            type: HardFormFieldTypeEnum.Input,
            title: "Время начала смены",
            params: {
              mask: "Hh:m0:s0",
            },
          },
          {
            name: "endTime",
            type: HardFormFieldTypeEnum.Input,
            title: "Время окончания смены",
            params: {
              mask: "Hh:m0:s0",
            },
          },
          {
            name: "workStartTime",
            type: HardFormFieldTypeEnum.Input,
            title: "Начало рабочего времени",
            params: {
              mask: "Hh:m0:s0",
            },
          },
          {
            name: "workEndTime",
            type: HardFormFieldTypeEnum.Input,
            title: "Окончание рабочего времени",
            params: {
              mask: "Hh:m0:s0",
            },
          },
        ],
      },
    },
    {
      name: "icon",
      title: "Иконка",
      type: HardFormFieldTypeEnum.Icon,
      params: {
        dicType: PathIcons,
      },
    },
  ];

  tableConfig: ITable<IShift[]> = {
    showDefaultActions: true,
    tableColumns: "44px 60px repeat(3, 1fr) auto",
    columns: [
      {
        title: "№",
        name: "id",
        type: HardTableColumnTypeEnum.Index,
      },
      {
        title: "Иконка",
        name: "icon",
        type: HardTableColumnTypeEnum.Icon,
        class: "px-2 py-1 flex items-center justify-center",
      },
      {
        title: "Наименование",
        name: "name",
        type: HardTableColumnTypeEnum.Translate,
      },
      {
        title: "Начало смены",
        name: "startTime",
        type: HardTableColumnTypeEnum.Text,
      },
      {
        title: "Конец смены",
        name: "endTime",
        type: HardTableColumnTypeEnum.Text,
      },
    ],
  };

  saveCallback = (data: IShift) => {
    const fields = ["startTime", "endTime", "workStartTime", "workEndTime"];

    fields.forEach((field) => {
      if (data[field]) {
        data[field] = formatTimeField(data[field]);
      }
    });

    return data;
  };
}
